import axios from 'axios';
import React, { Component } from 'react';
import * as Constants from "../../Constants/index";
import swal from "sweetalert";

class VerifyOtp extends Component {
    constructor(props) {
      super(props);
      this.state = {
        otp: '',
      };
    }
  
    handleChange = (event) => {
      const value = event.target.value;
      if (/^\d{0,6}$/.test(value)) {
        this.setState({ otp: value });
      }
    };
  
    handleSubmit =  async (event) => {
      event.preventDefault();
      const getNumber = localStorage.getItem("mobileNumber")
        console.log('OTP Submitted:', this.state.otp);
      const res =   await axios.post(Constants.api + `auth/verify-otp`, {
            otp: this.state.otp,
            mobile:getNumber
        }, {
             headers: {
             appVersion: Constants.av,
             platform: Constants.pt,
             "Accept-Language": localStorage.getItem("language"),
             company: 1,
             program: 1,
            }
        })
        .then((response)=>{
            if (response.status === 200) {
                if (response.data.code === 10001) {
                  const user = response.data.output.user;
        
                //   if (user.userType === 'ADMIN'|| user.userType === "HO") {
                    swal(response.data.msg);
                    localStorage.setItem('userid', user.id);
                    localStorage.setItem('usertype', user.userType);
                    localStorage.setItem('username', user.name);
                    localStorage.setItem('useremail', user.email);
                    localStorage.setItem('usermobile', user.mobile);
                    localStorage.setItem('token', response.data.output.access.token);
                    localStorage.setItem('refreshtoken', response.data.output.refresh.token);
        
                    window.location = '/dashboard';
                //   } else {
                //     swal("Error: You do not have admin access.");
                //   }
                } else if (response.data.code === 16001) {
                  swal(response.data.msg);
                  this.setState({ otpShow: true });
                } else {
                  swal(response.data.msg);
                }
              } else {
                swal(response.data.msg);
              }
        })

        console.log("res......",res)
    };
  
    render() {
      return (
        <div>
          <main className="main-content mt-0">
            <div className="page-header align-items-start min-vh-100">
              <span className="mask bg-gradient-dark opacity-6"></span>
              <div className="container my-auto">
                <div className="row">
                  <div className="col-lg-4 col-md-8 col-12 mx-auto">
                    <div className="card z-index-0 fadeIn3 fadeInBottom">
                      <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                        <div className="bg-gradient-primary shadow-primary border-radius-lg py-3 pe-1">
                          <h4 className="text-white font-weight-bolder text-center mt-2 mb-0">Sign in</h4>
                        </div>
                      </div>
                      <div className="card-body">
                        <form role="form" className="text-start" onSubmit={this.handleSubmit}>
                          <div className="input-group input-group-outline my-3">
                            <input
                              className="form-control"
                              name="otp"
                              placeholder="Verify-Otp"
                              value={this.state.otp}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="text-center">
                            <button type="submit" className="btn bg-gradient-primary w-100 my-4 mb-2">
                              Verify OTP
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <footer className="footer position-absolute bottom-2 py-2 w-100">
                <div className="container">
                  <div className="row align-items-center justify-content-lg-between">
                    {/* <div className="col-12 col-md-6 my-auto">
                      <div className="copyright text-center text-sm text-white text-lg-start">
                        © {new Date().getFullYear()}, Developed by
                        <a
                          href="https://www.wemonde.com"
                          className="font-weight-bold text-white"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Wemonde
                        </a>
                      </div>
                    </div> */}
                  </div>
                </div>
              </footer>
            </div>
          </main>
        </div>
      );
    }
  }
  
  export default VerifyOtp;